import SGloopMainList from "./SGloopMainList";
import EmptyStateCard from "./EmptyStateCard";
import SGloopSubMainCard from './SGloopSubMainCard';

export default function SummaryCard({ userData }) {

  return (
    <div className="bg-white rounded-2xl shadow p-4 sticky top-8 space-y-4">
      {/* SGloop Communities */}
      <h3 className="font-semibold">SGloop Communities</h3>
      {userData?.oneSGMain?.length > 0 ? (
        <SGloopMainList userData={userData} />
      ) : (
        <EmptyStateCard
          message="You haven’t joined any groups yet"
          buttonText="Explore Groups"
        />
      )}

      {/* SGloop Sub Communities */}
      <h3 className="font-semibold">SGloop Sub Communities</h3>
      <div className="text-sm text-gray-600">
        {userData?.oneSGGroupRef?.length > 0 ? (
          <SGloopSubMainCard userData={userData} />
        ) : (
          <EmptyStateCard
            message="You haven’t joined any groups yet"
            buttonText="Explore Groups"
          />
        )}
      </div>
    </div>
  );
}
